import React, { useState, useEffect,useRef  } from 'react';
import './Age.css'; 
// import Sidebar from '../../components/Sidebar';

function AgewiseReport() {
  const [students, setStudents] = useState([]);
  const [classOptions, setClassOptions] = useState([]);
  const [ageCountsByClass, setAgeCountsByClass] = useState({});
  const [selectedCell, setSelectedCell] = useState({ ageGroup: '', className: '', students: [], position: { x: 0, y: 0 } });
    const [schoolData, setSchoolData] = useState(null); 

    const [logoURL, setLogoURL] = useState(null);
  
  const [udiseNumber, setUdiseNumber] = useState("");
  const detailRef = useRef(null);

  useEffect(() => {
    const schoolUdiseNumber = localStorage.getItem("udiseNumber");
    if (schoolUdiseNumber) {
      setUdiseNumber(schoolUdiseNumber);
    }
  }, []);

  const [language, setLanguage] = useState(localStorage.getItem('language') || 'English');


  const openIndexedDB = () => {
    return new Promise((resolve, reject) => {
      const request = indexedDB.open('SchoolManagementDB', 1); // Use your actual DB name and version

      request.onerror = (event) => {
        console.error("IndexedDB error:", event.target.error);
        reject("Error opening IndexedDB");
      };

      request.onsuccess = (event) => {
        resolve(event.target.result);
      };

      request.onupgradeneeded = (event) => {
        const db = event.target.result;
        if (!db.objectStoreNames.contains('studentData')) {
          db.createObjectStore('studentData', { keyPath: 'id' });
        }
      };
    });
  };



  useEffect(() => {
    const storedLanguage = localStorage.getItem('language') || 'English';
    setLanguage(storedLanguage);
  }, []);

  useEffect(() => {
   const fetchData = async () => {
    try {
      const db = await openIndexedDB();
      const transaction = db.transaction(['studentData'], 'readonly');
      const objectStore = transaction.objectStore('studentData');
      const allRecords = objectStore.getAll();

      allRecords.onsuccess = (event) => {
        const data = event.target.result;
        if (data) {
          const activeStudents = data.filter(student => student.isActive !== false); // Only include active students

          setStudents(activeStudents);
          // setStudents(data);
          const classSet = new Set(activeStudents.map(student => student.currentClass).filter(Boolean));
          setClassOptions(Array.from(classSet));
        }
      };

      allRecords.onerror = (event) => {
        console.error('Error fetching student data from IndexedDB:', event.target.error);
      };
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  
    fetchData();
  }, [udiseNumber]);
  
  useEffect(() => {
    if (students.length > 0) {
      const ageCountsObj = {};

      students.forEach(student => {
        const age = calculateAge(student.dob);
        if (age === null) return; 
        const studentClass = student.currentClass;
        const ageGroup = `${age}-${age + 1}`;

        if (!ageCountsObj[ageGroup]) {
          ageCountsObj[ageGroup] = {};
        }

        if (!ageCountsObj[ageGroup][studentClass]) {
          ageCountsObj[ageGroup][studentClass] = 0;
        }

        ageCountsObj[ageGroup][studentClass]++;
      });

      // Sort age groups
      const sortedAgeGroups = Object.keys(ageCountsObj).sort((a, b) => {
        const [aMin] = a.split('-').map(Number);
        const [bMin] = b.split('-').map(Number);
        return aMin - bMin;
      });

      const sortedAgeCountsByClass = {};
      sortedAgeGroups.forEach(ageGroup => {
        sortedAgeCountsByClass[ageGroup] = ageCountsObj[ageGroup];
      });

      setAgeCountsByClass(sortedAgeCountsByClass);
    }
  }, [students]);

  const calculateAge = (dob) => {
    const dobDate = new Date(dob);
    if (isNaN(dobDate.getTime())) {
      return null; // Return null for invalid dates
    }
    const ageDiffMs = Date.now() - dobDate.getTime();
    const ageDate = new Date(ageDiffMs);
    return Math.abs(ageDate.getUTCFullYear() - 1970);
  };

  const handleCellClick = (ageGroup, className, event) => {
    const selectedStudents = students.filter(student => {
      const age = calculateAge(student.dob);
      const studentAgeGroup = `${age}-${age + 1}`;
      return studentAgeGroup === ageGroup && student.currentClass === className;
    });

    const rect = event.target.getBoundingClientRect();
    const xPos = rect.left;
    const yPos = rect.top + rect.height;

    setSelectedCell({ ageGroup, className, students: selectedStudents, position: { x: xPos, y: yPos } });
  };

  useEffect(() => {
    function handleClickOutside(event) {
      if (detailRef.current && !detailRef.current.contains(event.target)) {
        setSelectedCell({ ageGroup: '', className: '', students: [], position: { x: 0, y: 0 } });
      }
    }
  
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [detailRef]);

  const handlePrint = () => {
    const printContent = document.querySelector('.main-content-of-page'); // Adjust selector to match your layout
  
    if (printContent) {
      const cloneContent = printContent.cloneNode(true); // Clone the main content
  
      // Open a new window for printing
      const printWindow = window.open('', '', 'height=800,width=1000');
      printWindow.document.write(`
        <html>
          <head>
            <style>
              @page {
                size: A4 landscape;
                margin: 3mm;
                padding: 15px;
                border: 1px solid black;
              }
              body {
                font-family: Arial, sans-serif;
                margin: 0;
                padding: 0;
              }
              table {
                border-collapse: collapse;
                width: 100%;
                font-size: 16px;
              }
              th, td {
                border: 1px solid black;
                text-align: center;
                padding: 5px;
              }
              td {
                font-size: 16px;
              }
              th {
                background-color:  rgb(166 214 245);
              }
              .print-button {
                display: none;
              }
              .school-header-container {
                display: flex;
                align-items: center;
                justify-content: center;
                width: 100%;
              }
              .school-header2 {
                display: flex;
                align-items: center;
                justify-content: flex-start;
                flex: 0 0 auto; /* Prevent this section from growing */
                margin-right: 10px;
              }
              .school-header2 img {
                max-height: 70px;
              }
              .school-header {
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                text-align: center; margin-left:-70px;
                flex: 1 1 auto; /* This makes the school header take available space */
              }
              .school-header h1 {
                font-size: 28px;
                margin: 5px 0;
                text-overflow: ellipsis;
                white-space: nowrap;
              }
              .school-header .report-title {
                font-size: 20px;
                margin: 5px auto;
                font-weight: bold;
                border: 1px solid black;
                width: 200px;
                padding: 5px;
                text-align: center;
                border-radius: 10px;
                background-color: black;
                color: white;
              }
              .school-header .report-tit {
                font-size: 16px;
                margin: 5px auto;
                font-weight: bold;
                text-align: center;
              }
            </style>
          </head>
          <body>
             <div class="school-header-container">
              <div class="school-header2">
                ${logoURL ? `<img src="${logoURL}" alt="School Logo" onload="window.print()">` : '<div></div>'}
              </div>
              <div class="school-header">
                <div style="margin-left: 15px;">
                  <h1>${schoolData ? schoolData.schoolName : " "}</h1>
                  <div class="report-tit">
                    ${language === 'English' ? 'Taluka' : 'तालुका'} ${schoolData ? schoolData.taluka : " "} , ${language === 'English' ? 'District' : 'जिल्हा'} : ${schoolData ? schoolData.jilha : " "}
                  </div>
                  <div class="report-title">
                    ${language === "English" ?  "Age Wise Report" : "वयानुसार अहवाल"}
                  </div>
                </div>
              </div>
            </div>
            <style>
              .styled-table {
                box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
              }
            </style>
            ${cloneContent.outerHTML}
          </body>
        </html>
`);

      printWindow.document.close();
  
      // Focus and print the window after the image is loaded
      if (logoURL) {
        const img = printWindow.document.querySelector('.school-header2 img');
        img.onload = () => {
          printWindow.focus();
          printWindow.print();
          printWindow.close();
        };
      } else {
        printWindow.focus();
        printWindow.print();
        printWindow.close();
      }
    } else {
      console.error('Content to print not found');
    }
  };
  

  const fetchSchoolData = async () => {
    if (udiseNumber) {
      try {
        const db = await openIndexedDB();
        const transaction = db.transaction(['schoolData'], 'readonly');
        const objectStore = transaction.objectStore('schoolData');
        const request = objectStore.get(udiseNumber);

        request.onsuccess = (event) => {
          const data = event.target.result;
          if (data) {
            setSchoolData(data);
            setLogoURL(data.schoolLogo); // Set the logo URL
          }
        };

        request.onerror = (event) => {
          console.error("Error fetching school data:", event.target.error);
        };
      } catch (error) {
        console.error('Error fetching school data:', error);
      }
    }
  };

  useEffect(() => {
    fetchSchoolData ();
}, [udiseNumber]);
  return (
    <div>
    
    <h3  style={{marginTop:'90px', color:'#1B4332', fontWeight:'600', textAlign:'center', marginBottom:'-80px'}}>{language === "English" ? "Age Wise Report" : "वयानुसार अहवाल"}</h3>

    <div className='main-content-of-page'>

    <style>
        {`
          @media print {
       
            .styled-table td {
              background-color: transparent !important;
              -webkit-print-color-adjust: exact;
            }
           .styled-table th {
              background-color:  rgb(166 214 245) !important; /* Set the background color for the first row */
            }
            .print-button {
              display: none;
            }
            .custom-heading-text {
              margin: -5px auto;
            }
          }
        `}
      </style>
  
      <button onClick={handlePrint} className="print-button btn btn-primary" style={{ position: "absolute", right: 20, top: 90 }}>Print</button>
      <center style={{ padding:'-10px', marginBottom:'20px' }}>
          <div id="print-title" className="text-center" style={{ marginTop: '10px', fontWeight: 'bold' }}></div>
          <div className="custom-heading"  style={{paddingBottom:'-20px', marginTop:'-10px'}}>
          </div>
        </center>
      
      <div >
        <table  className="styled-table ">
          <thead>
            <tr>
              <th style={{backgroundColor:' rgb(166 214 245)' ,fontWeight:'bold'}} className="age-group-header"><center>{language === "English" ? "Age Group" : "वयोगट"}</center></th>
              <th  style={{backgroundColor:' rgb(166 214 245)' ,fontWeight:'bold' }} colSpan={classOptions.length}><center>{language === "English" ? "Class" : "वर्ग"}</center></th>
            </tr>
            <tr>
  <th style={{ backgroundColor: ' rgb(166 214 245)', border: '1px solid black'  ,fontWeight:'bold'}}></th>
  {classOptions.map((classNumber, index) => (
    <th style={{ backgroundColor: ' rgb(166 214 245)', border: '1px solid black' ,fontWeight:'bold' }} key={index}>
      {classNumber}
    </th>
  ))}
</tr>

          </thead>
          <tbody>
            {Object.keys(ageCountsByClass).map((ageGroup, index) => (
              <React.Fragment key={index}>
                <tr>
                  <td className="age-group-header">{ageGroup}</td>
                  {classOptions.map((className, idx) => {
                    const count = ageCountsByClass[ageGroup] && ageCountsByClass[ageGroup][className]
                      ? ageCountsByClass[ageGroup][className]
                      : 0;
                    return (
                      <td
                        key={idx}
                        className="class-column"
                        onClick={(event) => handleCellClick(ageGroup, className, event)}
                        style={{ color: count === 0 ? 'black' : 'green', position: 'relative' }}
                      >
                        {count}
                      </td>
                    );
                  })}
                </tr>
                {selectedCell.ageGroup === ageGroup && selectedCell.className === classOptions.find(cls => cls === selectedCell.className) && selectedCell.students.length > 0 && (
                  <tr className="student-detail-row"  ref={detailRef}  style={{ left: selectedCell.position.x - 140, top: selectedCell.position.y + 10 }}>
                    <td colSpan={classOptions.length + 1}>
                      <table className="student-info-table">
                        <thead>
                          <tr>
                            <th className='text-center'>{language === "English" ? "Name" : "नाव"}</th>
                          </tr>
                        </thead>
                        <tbody>
                          {selectedCell.students.map((student, idx) => (
                            <tr key={idx}>
                              <td>{student.stdName} {student.stdFather} {student.stdSurname}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </td>
                  </tr>
                )}
              </React.Fragment>
            ))}
          </tbody>
        </table>
      </div>
      </div>
    </div>
  );
}

export default AgewiseReport;